import { PackageVariantClosedIcon } from './PackageVariantClosedIcon';

/**
 * author: Austin Andrews
 * id 290F16B3-147C-446D-B14B-56AECCA76276
 * name package-variant-closed
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/package-variant-closed.svg
 * tags
 */
export const BoxVariantClosedIcon = PackageVariantClosedIcon;
export default BoxVariantClosedIcon